// extracted by mini-css-extract-plugin
export default {"button":"FullChangesJson_button__JHqJv","overlayContent":"FullChangesJson_overlayContent__TUrW6"};